module.exports = __webpack_public_path__ + "flyer-poster-b327c5876dabf48fee357e97a0dda27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flyer-poster.png
// module id = 1295
// module chunks = 1